<div class="master-ref flex flex-row align-middle mt-[2%]">
    <div class="master-title !bg-tw-primary min-w-[35%] h-12 skeleton">
        <h1 class="w-full skeleton-progress"> </h1>
    </div>
    <ngx-skeleton-loader></ngx-skeleton-loader>
    <div class="separator border-t-[1px] border-gray-300 h-1px w-full mx-2"></div>
    <div class="justify-end text-tw-primary">
        <button mat-stroked-button class="!rounded-xl px-2 skeleton !w-40">
            <div class="flex items-center  skeleton-progress">
                <div class="h-[2.5em] mr-1">
                </div>
                <div class="h-[2.5em]">
                </div>
            </div>
        </button>
    </div>
</div>
<table class="w-full">
    <thead>
        <tr>
            <!-- THUMB -->
            <th class="w-[5%] table-header"><span class="header-title">{{ 'THUMB' | translate }}</span></th>
            <!-- NAME -->
            <th class="w-[20%] table-header"><span class="header-title">{{ 'JOB_NAME' | translate }}</span></th>
            <!-- EASYDIADEM -->
            <th class="w-[5%] table-header"><!-- EasyDiadem? --><span class="header-title"></span></th>
            <!-- FLOW -->
            <th class="w-[5%] table-header"><!-- FLOW --><span class="header-title"></span></th>
            <!-- EXTERN -->
            <th class="w-[15%] table-header bordered"><span class="header-title pl-4">{{ 'EXTERN_STATE' | translate }}</span></th>
            <!-- INTERN -->
            <th class="w-[15%] table-header bordered" *ngIf="!isClient()"><span class="header-title pl-4">{{ 'INTERN_STATE' | translate }}</span></th>
            <!-- MEMBERS -->
            <th *ngIf="isClient()" class="w-[15%] table-header bordered"><span class="header-title pl-4">{{ 'APPROVAL.TITLE' | translate }}</span></th>
            <!-- LINKS -->
            <th class="w-auto table-header bordered"><span class="header-title pl-2">{{ 'SPLITVIEWS' | translate }}</span></th>
            <!-- DATE -->
            <th class="w-[10%] table-header"><span class="header-title px-4">{{ 'CREATION_DATE' | translate }}</span></th>
            <!-- ACTIONS -->
            <th class="w-[10%] table-header" *ngIf="!isClient()"><span class="header-title">{{ 'ACTIONS' | translate }}</span></th>
        </tr>
    </thead>
    <tbody>
        <!-- CHILD CARD -->
        <ng-component [ngTemplateOutlet]="skeletonChild"></ng-component>
        <ng-component [ngTemplateOutlet]="skeletonChild"></ng-component>
    </tbody>
</table>




<ng-template #skeletonChild>
    <tr class="min-h-[6em] border-b-gray-200 last:border-b-0 border-b-[1px] hover:bg-tw-primary hover:bg-opacity-20">
        <!-- THUMBNAILS -->
        <td class="w-[5%]">
            <img class="thumb" [style.height]="'2.5rem*'" [src]="'/assets/thumbnail-default.jpg'" />
        </td>
        <!-- NAME -->
        <td class="w-[20%] p-2">
            <span class="flex skeleton items-center justify-start w-full min-h-[1.5rem]">
                <span class="skeleton-progress"></span>
            </span>
        </td>
        <!-- EasyDiadem  -->
        <td class="w-[5%]">
            <div class="flex items-center justify-center gap-2">
                <ngx-skeleton-loader appearance="circle"></ngx-skeleton-loader>
            </div>
        </td>
        <!-- FLOWS  -->
        <td class="w-[5%]">
            <div class="flex flex-col items-center justify-center">
                <span class="flex flow-type border-b-grey border-b-2 border-dashed items-center w-16 min-h-[3rem]">
                    <span class="skeleton h-[1.5rem] w-8 ">
                        <span class="skeleton-progress"></span>
                    </span>
                </span>
                <span class="flex flow-type items-center min-h-[3rem] w-16">
                    <span class="skeleton h-[1.5rem] w-8 ">
                        <span class="skeleton-progress"></span>
                    </span>
                </span>
            </div>
        </td>
        <!-- EXTERN_STATE -->
        <td class="w-[15%] states">
            <div class="flex justify-between align-middle bg-gray-300 bg-opacity-20">
                <div class="flex flex-col align-top justify-center flex-grow">
                    <div class="extern-status flex pl-4 border-b-white min-h-[3em]">
                        <div class="flex justify-between align-middle h-fit !self-center">
                            <div class='w-[10em] flex gap-2'>
                                <div class="flex items-center gap-2 bold italic" [ngClass]="'init'">
                                    <div class="size-3 rounded-lg" [ngClass]="['bg-init']"></div>
                                    <span class="w-[7rem] min-h-[1.5rem] skeleton">
                                        <span class="skeleton-progress"></span>
                                    </span>
                                </div>
                            </div>
                            <div class="bg-tw-text-light text-tw-blue border-tw-blue ml-3 border-[1px] flex align-middle justify-center w-[2em] h-[2em]">
                                <div class="flex leading-[2em]"> R1 </div>
                            </div>
                        </div>
                    </div>

                    <div class="extern-status flex pl-4 border-b-white min-h-[3em]">
                        <div class="flex justify-between align-middle h-fit !self-center">
                            <div class='w-[10em] flex gap-2'>
                                <div class="flex items-center gap-2 bold italic" [ngClass]="'init'">
                                    <div class="size-3 rounded-lg" [ngClass]="['bg-init']"></div>
                                    <span class="w-[7rem] min-h-[1.5rem] skeleton">
                                        <span class="skeleton-progress"></span>
                                    </span>
                                </div>
                            </div>
                            <div class="bg-tw-text-light text-tw-blue border-tw-blue ml-3 border-[1px] flex align-middle justify-center w-[2em] h-[2em]">
                                <div class="flex leading-[2em]"> V1 </div>
                            </div>
                        </div>
                    </div>

                </div>
                <button class="flex justify-center items-center w-[5em]" [disabled]="true"><mat-icon class="text-tw-mediumgrey">history</mat-icon></button>
            </div>
        </td>
        <!-- INTERN_STATE -->
        <td *ngIf="!isClient()" class="w-[15%] states">
            <div class="flex justify-between align-middle bg-tw-complementary">
                <div class="flex flex-col align-top justify-center flex-grow">
                    <div class="flex border-b-white min-h-[3em]">
                        <div class="flex justify-between align-middle h-fit !self-center">
                            <div class="state-color-rect min-h-[3em]" [ngClass]="'bg-none'"></div>
                            <div class="h-[1.5rem] w-[8rem] !self-center ml-2 text-tw-text-disabled italic skeleton">
                                <span class="w-full skeleton-progress"></span>
                            </div>
                        </div>
                    </div>

                    <div class="flex border-b-white min-h-[3em]">
                        <div class="flex justify-between align-middle h-fit !self-center">
                            <div class="state-color-rect min-h-[3em]" [ngClass]="'bg-none'"></div>
                            <div class="h-[1.5rem] w-[8rem] !self-center ml-2 text-tw-text-disabled italic skeleton">
                                <span class="w-full skeleton-progress"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- SEE INTERN HISTORY -->
                <button class="w-[5em]" [disabled]="true"><mat-icon class="text-tw-mediumgrey">visibility</mat-icon></button>
            </div>
        </td>
        <!-- LINKS -->
        <td>
            <div class="flex flex-col">
                <div class="flex border-b-grey justify-start items-center min-h-[3em]">
                    <button *ngIf="!isClient()" class="ml-2 relecture-btn" [disabled]="true">
                        <mat-icon svgIcon="check-mark" class="!size-3"></mat-icon>
                        <span class="leading-3">{{ "INTERN_TITLE" | translate }}</span>
                    </button>
                    <button class="ml-2 relecture-btn" [disabled]="true">
                        <mat-icon svgIcon="visibility" class="!size-3"></mat-icon>
                        <span class="leading-3">{{ (isClient()? "RELECTURE_EXTERN" : "EXTERN_TITLE") | translate }}</span>
                    </button>
                </div>
                <div class="flex border-b-grey justify-start items-center min-h-[3em]">
                    <button *ngIf="!isClient()" class="ml-2 relecture-btn" [disabled]="true">
                        <mat-icon svgIcon="check-mark" class="!size-3"></mat-icon>
                        <span class="leading-3">{{ "INTERN_TITLE" | translate }}</span>
                    </button>
                    <button class="ml-2 relecture-btn" [disabled]="true">
                        <mat-icon svgIcon="visibility" class="!size-3"></mat-icon>
                        <span class="leading-3">{{ (isClient()? "RELECTURE_EXTERN" : "EXTERN_TITLE") | translate }}</span>
                    </button>
                </div>
            </div>
        </td>
        <!-- CREATION DATE -->
        <td class="w-[10%]">
            <div class="flex flex-col items-start justify-center w-full px-4 gap-2">
                <span class="font-normal text-sm skeleton block w-[6rem] h-[1.2rem]">
                    <span class="skeleton-progress"></span>
                </span>
                <span class="flex justify-start items-center gap-2">
                    <img class="size-3" src="assets/svg/awe-user-circle.svg" />
                    <span class="font-extralight text-xs italic self-center skeleton block w-[6rem] h-[1.2rem]">
                        <span class="skeleton-progress"></span>
                    </span>
                </span>
            </div>
        </td>
        <!-- ACTIONS -->
        <td *ngIf="!isClient()" class="w-[10%]">
            <div class="flex justify-start">
                <ngx-skeleton-loader appearance="circle"></ngx-skeleton-loader>
                <ngx-skeleton-loader appearance="circle"></ngx-skeleton-loader>
                <ngx-skeleton-loader appearance="circle"></ngx-skeleton-loader>
            </div>
        </td>
    </tr>
</ng-template>